import { createSelector } from '@reduxjs/toolkit';

import {
  getAddedSensitivePropertyGroupAttributes,
  getIsSensitivePropertyGroupNameModified,
} from 'src/containers/ProjectDiagram/utils/draft/draftSensitivePropertyGroup';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';

export const sensitivePropertyGroupDraftChangesSelector = (
  projectId: string,
  name: string | undefined
) =>
  createSelector(diagramSnapshotSelector(projectId), (diagram) => {
    if (!diagram?.model?.modelData?.draftData || !name) {
      return {
        addedAttributes: new Set<string>(),
        isNameModified: false,
      };
    }

    const currentSpg =
      diagram.model.modelData.sensitivePropertyGroupsByName[name];
    const originalSpgName =
      diagram.model.modelData.draftData.originalSpgNamesByCurrentName[name];
    const previousSpg =
      diagram.model.modelData.draftData.prevModelData
        .sensitivePropertyGroupsByName[originalSpgName || name];
    const isNewSpg = !previousSpg;

    const isNameModified = getIsSensitivePropertyGroupNameModified({
      isNewSpg,
      originalSpgName,
    });

    const addedAttributes = getAddedSensitivePropertyGroupAttributes({
      currentSpg,
      previousSpg,
      isNewSpg,
    });

    return {
      addedAttributes,
      isNameModified,
    };
  });
